import Rollbar from 'rollbar'

import { ENV } from '@/config'

// For cases where Rollbar needs to be executed
// on development environment, set ROLLBAR_ENABLED to true or type "rollbar.configure({ enabled: true })"
// in your browser console.
const ROLLBAR_ENABLED = !['development', 'test'].includes(ENV)
const config = {
  enabled: ROLLBAR_ENABLED,
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  hostSafeList: ['neat.com'],
  payload: {
    environment: ENV,
    appBuild: process.env.NEXT_PUBLIC_BUILD_TAG,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: process.env.NEXT_PUBLIC_BUILD_TAG,
      },
    },
  },
}

const Instance = Rollbar.init(config)

export const trackRollbarPerson = ({ account, user }) => {
  Instance.configure({
    payload: {
      person: {
        id: user?.neatUserId,
        email: user?.email,
        username: `${user?.firstName} ${user?.lastName}`,
      },
      account: {
        id: account?.id,
      },
    },
  })
}

export const sendError = (error, message, extra) => {
  if (!ROLLBAR_ENABLED) return
  Instance.error(message || error.message, error, extra)
}

export const sendWarning = (error, message, extra) => {
  if (!ROLLBAR_ENABLED) return
  Instance.warning(message || error.message, error, extra)
}

export default Instance
